import { withNamespaces } from "react-i18next";
import React from "react";
import { Col, Container, Row } from "reactstrap";
import PageBody from "../../../components/page-body";
import Navigator from "src/components/Navigator";
import ListToms from "./pages/list-toms";

const TOMS = () => {
  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col lg="12" className="mb-4">
            <Navigator
              pageTitle="TOM"
              breadCrumbs={[
                {
                  title: "SIP",
                  link: `/admin/data-protection/dashboard`,
                },
                {
                  title: "TOM",
                  link: `/admin/data-protection/toms`,
                },
              ]}
            />
          </Col>
        </Row>

        <PageBody>
          <div className="p-4 mb-5">
            <ListToms />
          </div>
        </PageBody>
      </Container>
    </div>
  );
};

export default withNamespaces()(TOMS);
